export default class RegexUtils {
    static get phoneRegex() {
        return /^[+]?[0-9]{3}?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4}$/;
    }
}